export default "__VITE_ASSET__J2WmjJl6__"